import CourseItemHeader from "../Courses/courseItemHeader";
import Navbars from "../Navbar";
export default function AllCourse(){
    return <>
        <Navbars/>
        <CourseItemHeader/>
    </>
}